<template>
  <!-- 首年基础费用 -->
  <div class="content main-container">
    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="search-tools">
      <div class="search-box btn3" :class="{'close':!searchMore}">
        <div class="input-item">
          <span class="label">供应商类型</span>
          <RadioGroup v-model="searchParams.supplierType" @on-change="changeSupplierType">
            <Radio label="">全部</Radio>
            <Radio label="1">保险公司</Radio>
            <Radio label="2">合作通道</Radio>
          </RadioGroup>
        </div>
        <div class="input-item" v-if="searchParams.supplierType">
          <span class="label">供应商</span>
          <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
            <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" clearable filterable transfer>
            <Option
              v-for="(bean, i) in companyLists"
              :key="i"
              :value="bean.code"
              >{{ bean.name }}</Option
            >
          </Select>
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.dateType" :transfer="true" @on-change="changeDateType">
            <Option value="1">投保日期</Option>
            <Option value="2">支付日期</Option>
            <Option value="3">承保日期</Option>
            <Option value="4">生效日期</Option>
          </Select>
          <DatePicker v-model="searchParams.date" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime"></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">保单号</span>
          <Input
            v-model="searchParams.policyNo"
            placeholder="请输入"
            clearable
          />
        </div>
        <div class="input-item">
          <span class="label">批单号</span>
          <Input
            v-model="searchParams.billNo"
            placeholder="请输入"
            clearable
          />
        </div>
        <div class="input-item">
          <span class="label">保单状态</span>
          <Select v-model="searchParams.policyStatusList" clearable multiple>
            <Option value="1">已承保</Option>
            <Option value="-1">已退保</Option>
            <Option value="0">已终止</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">退保日期</span>
          <DatePicker v-model="searchParams.refundTime" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime4" :disabled="searchParams.isNull3"></DatePicker>
            <Checkbox v-model="searchParams.isNull3" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item">
          <span class="label">险种分类</span>
          <Select v-model="searchParams.themeIds" clearable filterable multiple>
            <Option v-for="(item, index) in themeList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
        <span class="label">上游结算状态</span>
        <Select v-model="searchParams.settlementStatus" transfer placeholder="请选择" clearable>
            <Option value="1">已结算</Option>
            <Option value="0">未结算</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">对账状态</span>
          <Select v-model="searchParams.reconciliationStatus" clearable>
            <Option value="0">未对账</Option>
            <Option value="1">对账正常</Option>
            <Option value="2">对账异常</Option>
            <Option value="3">已对账</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">对账日期</span>
          <DatePicker transfer v-model="searchParams.checkDate" format="yyyy-MM-dd" type="date"  @on-change="searchParams.checkDate = $event"
            placeholder="请选择" :disabled="searchParams.isNull4"></DatePicker>
            <Checkbox v-model="searchParams.isNull4" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item">
            <span class="label">所属对账单</span>
            <Select v-model="searchParams.reconciliationId" clearable filterable transfer :disabled="searchParams.reconciliationNull">
              <Option :value="item.reconciliationId" v-for="(item, index) in queryList" :key="index" >{{ item.reconciliationName }}</Option>
            </Select>
            <Checkbox v-model="searchParams.reconciliationNull" class="null" @on-change="changeTypeNull">为空</Checkbox>
        </div>  
        <div class="input-item">
          <span class="label">出单机构/团队</span>
          <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
        </div>
        <div class="input-item">
          <span class="label">出单业务员</span>
          <Select clearable v-model="searchParams.salesmanId" style="width:256px;" filterable :transfer="true">
            <Option :value="item.id" v-for="(item, index) in salesmanList" :key="index"
              :label="item.staffNo + (item.staffNo ? '/' : '') + item.name"></Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">回款状态</span>
          <RadioGroup
            v-model="searchParams.receivableStatus"
            @on-change="searchAjax();getSummaryData()"
          >
            <Radio label="">全部</Radio>
            <Radio label="1">已回款</Radio>
            <Radio label="0">未回款</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">付款状态</span>
          <RadioGroup v-model="searchParams.payStatus" @on-change="searchAjax();getSummaryData()">
            <Radio label="">全部</Radio>
            <Radio label="1">已付款
              <span class="tip-icon">?</span>
              <div class="pop-tip">
                <span>代收的保费是否已付款给供应商</span>
                <div class="arrow"></div>
              </div>
            </Radio>
            <Radio label="0">未付款</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">费用类型</span>
          <Select v-model="searchParams.commissionType" clearable>
            <Option value="1">基础费用</Option>
            <Option value="2">限时加费活动</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">业务类别</span>
          <Select v-model="searchParams.sellType" :transfer="true" clearable :disabled="searchParams.sellTypeNull">
            <Option value="1">网销</Option>
            <!-- <Option value="2">电销</Option> -->
            <Option value="3">经代</Option>
          </Select>
          <Checkbox v-model="searchParams.sellTypeNull" class="null" @on-change="changeTypeNull">为空</Checkbox>
        </div>
        <div class="input-item">
          <span class="label">是否扣款记录</span>
          <RadioGroup v-model="searchParams.queryDeduct" @on-change="searchAjax();getSummaryData()">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax();getSummaryData()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch();getSummaryData();selectTreeId=''">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore=false">收起<Icon type="ios-arrow-up" /></Button>
          <Button type="primary" ghost v-else @click="searchMore=true">展开<Icon type="ios-arrow-down" /></Button>
        </div>
      </div>
      <div class="tab-box">
        <Tabs v-model="searchParams.tab" :animated="false" @on-click="changeTabs">
          <TabPane
            :label="item.label"
            :name="item.value"
            v-for="item in tabList"
            :key="item.value"
          ></TabPane>
        </Tabs>
        <div class="tools-box left" >
          <Button type="primary" ghost @click="exportForm()">导出</Button>
        </div>
      </div>
      <div class="statistics-container">
        <div class="statistics-item">
          <span class="dot"></span>
          <span>保单数：</span>
          <span class="num">{{ summaryData.policyCounts || 0 }}</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>批单数：</span>
          <span class="num">{{ summaryData.billCounts || 0 }}</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>新契约保费：</span>
          <span class="num">{{ summaryData.policyFee || 0 }}</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>批单保费：</span>
          <span class="num">{{ summaryData.billFee || 0 }}元</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>上游已结算费用：</span>
          <span class="num">{{ summaryData.settledCommissionPrice || 0 }}元</span>
          <div>
            （
            <span>已完成对账费用：</span>
            <span class="num" style="padding-right:10px">{{ summaryData.settledReconciledCommissionPrice || 0 }}元</span>
            <span>未完成对账费用：</span>
            <span class="num">{{ summaryData.settledUnreconciliationCommissionPrice || 0 }}元</span>
            ）
          </div>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>上游未结算费用：</span>
          <span class="num">{{ summaryData.unsettleCommissionPrice || 0 }}元</span>
        </div>
      </div>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table
          :columns="columns"
          :data="tableData"
          class="table-wrap"
        >
          <template slot-scope="{ row }" slot="checkName">
            <div @click="lookStatement(row)" class="toDetailPage">
              {{ row.checkName }}
            </div>
          </template>
          <template slot-scope="{ row }" slot="reconciliationStatusDesc">
            <div>
              <i class="dian red" v-if="row.isOk == 2 || row.isOk == 3"></i>
              {{ row.reconciliationStatusDesc }}
            </div>
          </template>
          <template slot-scope="{ row }" slot="commissionPrice">
            <div class="commission-price" v-if="row.reviseCommissionPrice && row.isDeduct==1">
              <span>{{row.commissionPrice}}</span>
              <Tooltip
                trigger="hover"
                content="content"
                :transfer=true
                v-if = "row.deductMsg"
              >
                <div class="text-tag">扣款</div>
                <div slot="content">
                  <span>{{row.deductMsg}}</span>
                </div>
              </Tooltip>
              <div class="text-tag" v-else>扣款</div>
              <span>（已强平）</span>
            </div>
            <div class="commission-price" v-else-if="row.reviseCommissionPrice && row.isDeduct!=1">
              <span>{{row.commissionPrice}}</span>
              <span>（已强平）</span>
            </div>
            <div class="commission-price" v-else-if="!row.reviseCommissionPrice && row.isDeduct==1">
              <span>{{row.commissionPrice}}</span>
              <Tooltip
                trigger="hover"
                content="content"
                :transfer=true
                v-if = "row.deductMsg"
              >
                <div class="text-tag">扣款</div>
                <div slot="content">
                  <span>{{row.deductMsg}}</span>
                </div>
              </Tooltip>
              <div class="text-tag" v-else>扣款</div>
            </div>
            <div v-else>{{row.commissionPrice}}</div>
          </template>
          <template slot-scope="{ row }" slot="action">
              <div class="toDetailPage">
                  <span @click="openClasp(row,'扣款')" v-if="row.canDeduct == '1'">扣款</span>
                  <span v-else-if="row.canDeduct == '0'" style="color: #A8ADB7;">扣款</span>
                  <span @click="openClasp(row,'修改扣款')" v-if="row.isDeduct == '1' && row.reconciliationStatus!='3'">修改扣款</span>
                  <span v-else-if="row.isDeduct == '1' && row.reconciliationStatus=='3'" style="color: #A8ADB7;">修改扣款</span>
              </div>
          </template>
        </Table>
        <Page
          :total="total"
          :current.sync="pageNum"
          :page-size="pageSize"
          show-total
          @on-change="getList"
          style="text-align: center; margin-top: 20px"
        />
      </div>
    </div>

    <Modal v-model="visible" :title="title" :footer-hide="true" :mask-closable="false" class="my-modal top" width="80%">
      <Form ref="form" :model="formData" class="page-form" :label-width="120">
        <FormItem prop="policyNo" label="保单号：">
          <span>{{ formData.policyNo }}</span>
        </FormItem>
        <FormItem prop="settlementStatus" label="上游结算状态：">
          <span>{{ formData.settlementStatus }}</span>
        </FormItem>
        <FormItem label="对账状态">
          {{ formData.reconciliationStatusDesc }}
        </FormItem>
        <FormItem prop="refundFee" label="退费金额：">
          <span>{{ formData.refundFee }}</span>
          <span class="unit">元</span>
        </FormItem>
        <FormItem label="费用">
          {{ commissionPrice }}元
          <span v-if="formData.reviseCommissionPrice">(强平：{{ formData.reviseCommissionPrice }}元)</span>
        </FormItem>
        <FormItem prop="refundCommissionPrice" label="扣除费用：" :rules="$units.formRule.required('请输入扣除费用', 'change', 'number')">
          <div>
            <InputNumber v-model="formData.refundCommissionPrice" :min="0" placeholder="请输入" style="width: 60%"></InputNumber>
            <span class="unit">元</span>
          </div>
        </FormItem>
        <div class="less">
        <FormItem label="扣款原因：" prop="deductType" :rules="$units.formRule.required('请选择扣款原因', 'change')" style="width: 100%">
            <Select v-model="formData.deductType" placeholder="请选择" filterable clearable transfer>
              <Option value="1">退保</Option>
              <Option value="4">其他</Option>
            </Select>
          </FormItem>
        </div>
        <div class="full" v-if="formData.deductType == 4">
          <FormItem label="" prop="deductMsg" :rules="$units.formRule.required('请填写原因')" style="width: 100%">
            <Input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" v-model="formData.deductMsg" placeholder="请输入"/>
          </FormItem>
        </div>
      </Form>
      <div class="ivu-modal-footer">
        <Button @click="visible = false">取消</Button>
        <Button type="primary" @click="ok">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import selectTree from "@/components/system/selectTree3";
import { mapState } from "vuex";
import { pageTool } from "@/api/mixins";
import { upstreamColumns } from "./form/indexColumns";
import lzDicSelect from "@/components/commons/lzDicSelect";
export default {
  mixins: [pageTool],
  data: () => ({
    visible: false,
    title:'扣款',
    summaryData: {
      policyCounts: '',
      billCounts: '',
      policyFee: '',
      billFee: '',
      totalCommissionPrice: '',
      unsettleCommissionPrice:'',
      settledCommissionPrice:'',
      settledReconciledCommissionPrice:'',
      settledUnreconciliationCommissionPrice:''
    },// 系统汇总数据
    formData:{
      refundCommissionPrice:null,
      deductType:''
    },
    supplierList:[],
    settlementDocList: [],
    themeList: [],
    queryList:[],
    rowId:null,
    settlementVisible: false,
    settleLoading: false,
    settlementForm: {
      checkDate: "", // 结算日期
      checkId: "",
      type: "2",
    }, // 结算
    searchParams: {
      dateType: '3',
      dateType1:'1'
    },
    settlementFormRules: {
      checkId: [
        {
          required: true,
          message: "请选择我司批次",
          trigger: "change",
        },
      ],
      checkDate: [
        {
          required: true,
          message: "请选择结算日期",
          type: "date",
          trigger: "change",
        },
      ]
    },
    tabList: [
      {
        label: "上游对账数据",
        value: "1",
      },
    ],
    batchList: [], // 结算批次列表
    selectTreeId: "",
    addbatchVisible: false,
    addbatchForm: {},
    timeArray: [], // 承保时间
    value: "",
    commissionPrice:0,
    type: "", // 1首年;2续期
    tabModel: "1",
    salesmanList: [],//所属业务员
    tableData: [],
    sourceList: [],
    columns: [],
    addFormRules: {
      checkDate: [
        {
          required: true,
          message: "请选择结算日期",
          type: "date",
          trigger: "change",
        },
      ],
      checkId: [
        {
          required: true,
          message: "请选择批次",
          trigger: "change",
        },
      ],
      settleDate: [
        {
          required: true,
          type: "date",
          message: "请选择结算日期",
          trigger: "change",
        },
      ],
    },
    addForm: {
      amount: "", //总保费
      billNum: "", //发票号
      checkAmount: "", //总核收金额
      checkDate: "", //核收日期
      checkType: "", //1首年核收  2、预收
      checkUser: "", //核收人
      commissionIdList: [],
      consultRemark: "", //描述
      num: "", //数量
      type: "1", //1、多条 2、单条选择
      checkId: "", //总批次id
      settleDate:''
    },
    addVisible: false,
    settlementShow:false,
    btnLoading: false,
    tableLoading: false,
    companyLists: [], //保险公司列表
  }),
  components: { selectTree,lzDicSelect },
  computed: {
    ...mapState({
      companyList: "companyListEntity", //保险公司
      // themeList: 'themeListEntity', //产品分类
    }),
  },
  created() {
    // this.userInfo.userType = 4;
    this.columns = upstreamColumns;

    this.$root.$children[0].isShowLoading = false;
    this.type = 2;
    // 对账类型：1首期基础费用，2首期梯度加费费用，3首年后置费用，4续期基础费用，5继续率奖励费用，6续期其他费用
    this.searchParams.reconciliationType = 1;
    this.searchParams.tab ='1'
    this.initListAjax("/buz/commissionReconciliation/groupPolicy/result");
    this.getSource();
    this.getOrganizationUser(null)
    this.getSettlementDocList();
    this.getSummaryData()
  },
  mounted() {
    this.geCompanyList();
    this.queryTheme();
    this.getqueryList()
  },
  methods: {
    //获取汇总数据
    getSummaryData() {
      let params = Object.assign({}, this.searchParams);
      this.$http({
        url: '/buz/commissionReconciliation/group/statistics',
        type: 'POST',
        data: params,
      }).then((res) => {
        if (res.data) {
          this.summaryData = res.data
        }else{
          this.summaryData= {
            policyCounts: '',
            billCounts: '',
            policyFee: '',
            billFee: '',
            totalCommissionPrice: '',
            unsettleCommissionPrice:'',
            settledCommissionPrice:'',
            settledReconciledCommissionPrice:'',
            settledUnreconciliationCommissionPrice:''
          }
        }
      })
    },
    ok(){
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        let formData = {},url=''
        this.formData = JSON.parse(JSON.stringify(this.formData));
        // 保费及费用传参为负数
        formData.commissionPrice = -this.formData.refundCommissionPrice
        formData.fee = -this.formData.fee
        formData.deductType = this.formData.deductType
        formData.deductMsg = this.formData.deductMsg
        if(this.formData.deductType =='1'){
          formData.deductMsg = '退保'
        }
        if (this.formData.isDeduct == '1') {
          url = '/buz/commissionLog/changeDeduct';
          formData.id = this.formData.id
        } else {
          url = '/buz/commissionLog/deductCommission';
          formData.commissionLogId = this.formData.id
        }
        this.$http({
          url,
          type: 'POST',
          data: formData
        }).then(res => {
          this.visible = false;
          this.getList()
        });
      });
    },
    openClasp(row,title){
      this.visible  = true
      this.title = title
      this.$nextTick(() => {
        // 清除验证信息
        this.$refs.form &&
          this.$refs.form.fields.forEach(item => {
            item.validateState = '';
            item.validateMessage = '';
          });
      });
      this.formData = JSON.parse(JSON.stringify(row))
      this.formData.deductType = String(this.formData.deductType) 
      this.formData.refundCommissionPrice = Number(row.refundCommissionPrice)
      if(this.formData.isDeduct =='1'){
        this.formData.commissionPrice = -this.formData.commissionPrice
        this.formData.fee = -this.formData.fee
        this.getDetail(row.deductLogId, row);
      }else{
        this.commissionPrice = this.formData.commissionPrice
      }
    },
    getDetail(id, item) {
      this.$http({
        url: '/buz/commissionLog/read/detail',
        type: 'GET',
        data: {
          id
        }
      }).then(res => {
        this.commissionPrice = res.data.commissionPrice;
        this.formData.fee = Math.abs(item.fee);
        this.formData.commissionPrice = Math.abs(item.commissionPrice);
        this.formData.deductType = item.deductType;
        this.formData.deductMsg = item.deductMsg;
        this.formData.id = item.id;
      });
    },
    changeValue(value){
      this.searchParams[value] = this.searchParams[value].replace(/^0(0+)|[^\d]+/g, '') 
      this.searchParams[value] = this.searchParams[value] && Number(this.searchParams[value])
      return this.searchParams[value]
    },
    lookStatement(row){
      this.$router.push({
        name: "groupStatementDetail",
        query: { id: row.checkId,step:row.step,type:1 },
      });
    },
    // 所属结算单
    getSettlementDocList() {
      this.$http({
        url: '/buz/userSalaryReport/read/list',
        type: 'POST',
        data: { pageNo: 1, pageSize: 9999 }
      }).then(res => {
        this.settlementDocList = res.data;
      });
    },
    // 导出
    exportForm() {
      if(this.$units.pointAction('offline_9_1_2')){
        let params = this.searchParams;
        this.$root.$children[0].isShowLoading = true;
        this.$http({
          url: "/buz/commissionReconciliation/groupPolicy/exportExcel",
          type: "POST",
          data: params,
          responseType: "blob",
          forced: true,
          All: true,
          apiPermissionCode:'offline_10_2'
        })
          .then((res) => {
            this.$root.$children[0].isShowLoading = false;
            // json格式解析
            if (res.data.type == "application/json") {
              const reader = new FileReader();
              reader.onload = () => {
                let resp = JSON.parse(reader.result);
                if (resp) {
                  if (resp.httpCode != 1) {
                    this.$Message.error(resp.msg ? resp.msg : "导出失败");
                    return;
                  }
                }
              };
              reader.readAsText(res.data);
            } else {
              // blob格式下载
              this.$units.daochu(res);
            }
          })
          .catch((e) => {
            this.$root.$children[0].isShowLoading = false;
          });
        }else{
          this.$Message.error('无权操作，请联系您的上级')
        }
      
    },
    setReqParams(params){
        // 对账类型reconciliationType，1首期基础费用，2首期梯度加费，3首年后置费用，4续期基础费用，5继续率奖金
        params.reconciliationType = '1'
    },
    // 通过机构获取业务员
    getqueryList() {
      this.$http({
        url: `/buz/commissionReconciliation/queryList`,
        type: "POST",
        data: {
          reconciliationType:'1',
          policyType:2  //policyType，保单类型 1个险 2团险
        }
      }).then((res) => {
        this.queryList = res.data;
      })
    },
    // 通过机构获取业务员
    getOrganizationUser(id) {
      this.$http({
        url: `/buz/userBase/getByOrgIds`,
        type: "POST",
        data: {
          orgaList: id ? [id] : []
        }
      }).then((res) => {
        this.salesmanList = res.data;
      })
    },
    // 产品业务分类
    queryTheme() {
      this.$http({
        url: '/buz/commissionReconciliation/queryProductTheme',
        type: 'GET',
        data:{
          type:2 //type 1个险 2团险
        }
      }).then(res => {
        this.themeList = res.data;
      });
    },
    changeTypeNull(){
      if(this.searchParams.sellTypeNull){
        this.searchParams.sellType=''
        this.searchParams.sellTypeIsNull = '1'
      }else{
        this.searchParams.sellTypeIsNull = ''
      }

      if(this.searchParams.reconciliationNull){
        this.searchParams.reconciliationId = ''
        this.searchParams.reconciliationIdIsNull = '1'
      }else{
        this.searchParams.reconciliationIdIsNull = ''
      }
      
      if(this.searchParams.receiptStatusNull){
        this.searchParams.receiptStatusList = ''
        this.searchParams.receiptStatusIsNull = '1'
      }else{
        this.searchParams.receiptStatusIsNull = ''
      }

      if(this.searchParams.verifyStatusNull){
        this.searchParams.verifyStatusList = []
        this.searchParams.verifyStatusIsNull = '1'
      }else{
        this.searchParams.verifyStatusIsNull = ''
      }
    },
    // 各项日期处理
    changeDateType(){
        this.searchParams.date = []
        this.searchParams.holdTimeStart = '';
        this.searchParams.holdTimeEnd = '';

        this.searchParams.payTimeStart = '';
        this.searchParams.payTimeEnd = '';

        this.searchParams.insureTimeStart = '';
        this.searchParams.insureTimeEnd = '';

        this.searchParams.effectTimeStart = '';
        this.searchParams.effectTimeEnd	 = '';
    },
    changeDateType1(){
        this.searchParams.date1 = []
        this.searchParams.receiptDate2Start = '';
        this.searchParams.receiptDate2End	 = '';

        this.searchParams.receiptDateStart = '';
        this.searchParams.receiptDateEnd	 = '';
        this.changeDateNull()
    },
    changeDateNull(){
      if(this.searchParams.isNull){
        this.searchParams.date1 = []
        if(this.searchParams.dateType1=='1'){
          this.searchParams.receiptDate2Start = ''
          this.searchParams.receiptDate2End	 = ''

          this.searchParams.receiptDateIsNull = ''
          this.searchParams.receiptDate2IsNull = '1'
        }else if(this.searchParams.dateType1=='2'){
          this.searchParams.receiptDateStart = ''
          this.searchParams.receiptDateEnd	 = ''
          
          this.searchParams.receiptDate2IsNull = ''
          this.searchParams.receiptDateIsNull = '1'
        }
      }else{
        this.searchParams.receiptDate2IsNull = ''
        this.searchParams.receiptDateIsNull = ''
      }

      if(this.searchParams.isNull1){
        this.searchParams.revisitDate = []
        this.searchParams.revisitDateStart = ''
        this.searchParams.revisitDatEnd	 = ''
        this.searchParams.revisitDateIsNull = '1'
      }else{
        this.searchParams.revisitDateIsNull = ''
      }

      if(this.searchParams.isNull2){
        this.searchParams.hesitateDate = []
        this.searchParams.hesitateDateStart = ''
        this.searchParams.hesitateDateEnd	 = ''
        this.searchParams.hesitateDateIsNull = '1'
      }else{
        this.searchParams.hesitateDateIsNull = ''
      }

      if(this.searchParams.isNull3){
        this.searchParams.refundTime = []
        this.searchParams.refundTimeStart = ''
        this.searchParams.refundTimeEnd	 = ''
        this.searchParams.refundTimeIsNull = '1'
      }else{
        this.searchParams.refundTimeIsNull = ''
      }

      if(this.searchParams.isNull4){
        this.searchParams.checkDate = ''
        this.searchParams.checkDateIsNull = '1'
      }else{
        this.searchParams.checkDateIsNull = ''
      }
    },
    changeTime(time) {
      if(this.searchParams.dateType == '1'){
        this.searchParams.holdTimeStart = time[0];
        this.searchParams.holdTimeEnd = time[1];
      }else if(this.searchParams.dateType == '2'){
        this.searchParams.payTimeStart = time[0];
        this.searchParams.payTimeEnd = time[1];
      }else if(this.searchParams.dateType == '3'){
        this.searchParams.insureTimeStart = time[0];
        this.searchParams.insureTimeEnd = time[1];
      }else if(this.searchParams.dateType == '4'){
        this.searchParams.effectTimeStart = time[0];
        this.searchParams.effectTimeEnd	 = time[1];
      }
    },
    changeTime1(time) {
      if(this.searchParams.dateType1 == '1'){
        this.searchParams.receiptDate2Start = time[0];
        this.searchParams.receiptDate2End	 = time[1];
      }else if(this.searchParams.dateType1 == '2'){
        this.searchParams.receiptDateStart = time[0];
        this.searchParams.receiptDateEnd	 = time[1];
      }
    },
    changeTime2(time) {
      this.searchParams.revisitDateStart = time[0];
      this.searchParams.revisitDatEnd	 = time[1];
    },
    changeTime3(time) {
      this.searchParams.hesitateDateStart = time[0];
      this.searchParams.hesitateDateEnd	 = time[1];
    },
    changeTime4(time) {
      this.searchParams.refundTimeStart = time[0];
      this.searchParams.refundTimeEnd	 = time[1];
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.searchParams.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all'
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list'
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then((res) => {
          this.supplierList = res.data;
        })
      }
      this.searchFun();
    },
    changeTabs(value) {
      this.columns = upstreamColumns;
      this.searchAjax();

    },
    //列表保险公司
    geCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: "POST",
        data:{companyType:"1"}
      }).then((res) => {
        this.companyLists = res.data;
      });
    },
    getSource() {
      this.$http({
        url: "/buz/productBase/getProductSource",
        type: "get",
      }).then((res) => {
        this.sourceList = res.data;
      });
    },
    // 生成结算周期
    generateSettle1() {
      this.settlementShow = true;
      this.$refs["addFormRef1"] && this.$refs["addFormRef1"].resetFields();
    },

    //生成结算批次
    generateSettle() {
      this.$nextTick(() => {
        this.$refs["addFormRef"] && this.$refs["addFormRef"].resetFields();
      });
      // 核收模型
      this.getSettleDetail();
      // 所有批次
      this.getCheckNo();
    },
    // 获取所有批次
    getCheckNo() {
      this.$http({
        url: "/buz/molCommissionCheck/read/allCheckNo",
        type: "POST",
        data: {
          source: this.searchParams.tab == '1'?"1":"2",
          commissionIndex:this.searchParams.commissionIndex
        },
      }).then((res) => {
        this.batchList = res.data;
      });
    },
    // 新增批次
    saveBatch() {
      this.$units.notCloseModal(this);
      this.$refs["addbatchRef"].validate((valid) => {
        if (valid) {
          this.$http({
            url: "/buz/molCommissionCheck/add",
            type: "POST",
            data: {
              checkName: this.addbatchForm.checkName,
              commissionIndex:this.searchParams.commissionIndex,
              checkDate: this.$units.formatDate(
                this.addbatchForm.checkDate,
                "yyyy-MM-dd"
              ),
              source:this.searchParams.tab == '1'?'1':'2'
            },
          }).then((res) => {
            if (res.httpCode == 1) {
              this.$Message.success("新增成功");
              this.getCheckNo();
            }
            this.addbatchVisible = false;
          });
        }
      });
    },
    // 选择批次
    selectBatch(formData, id) {
      const data = this.batchList.find((item) => {
        return item.id == id;
      });
      this.$set(formData, "checkDate", data.checkDate);
    },
    getSettleDetail() {
      this.settleLoading = true;
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.$http({
        url: "/buz/commissionLog/getCheckModel",
        type: "post",
        data: params,
        apiPermissionCode:'offline_10_1'
      })
        .then((res) => {
          this.settleLoading = false;
          if (res.httpCode == 1) {
            this.addForm = res.data;
            this.addForm.checkDate = "";
            this.addVisible = true;
          }
        })
        .catch((e) => {
          this.settleLoading = false;
        });
    },
    // 机构树选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {
        //机构
        this.searchParams.policyOrgId = data.id;
        this.searchParams.groupId = "";
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.policyOrgId = "";
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.policyOrgId = "";
        this.searchParams.groupId = "";
      }
    },

    setListParams(params) {
      this.$units.delNull(params);
    },

    saveSettlement() {
      this.settlementForm.type = "2";
      this.$refs['settlementFormRef'].validate((valid) => {
        if (valid) {
          this.$http({
            url: "/buz/commissionLog/batchAcceptCommission",
            type: "POST",
            data: this.settlementForm,
          }).then((res) => {
            if (res.httpCode == 1) {
              this.$Message.success("操作成功");
              this.getList();
            }
            this.settlementVisible = false;
          });
        }
      });
    },
    // 生成结算周期
    saveAddBatch() {
      this.settleLoading = true;
      this.$units.notCloseModal(this);
      this.$refs['addFormRef1'].validate((valid) => {
        if (valid) {
          let params = {}
          params.settleDate = this.$units.formatDate( this.addForm.settleDate, "yyyy-MM-dd" );
          if(this.rowId){
            params.id = this.rowId;
          }

          this.$http({
            url: '/buz/commissionLog/baseCommissionSettlement',
            type: "POST",
            data: params,
            apiPermissionCode:'offline_10_4'
          }).then((res) => {
            this.settleLoading = false;
            if (res.httpCode == 1) {
              this.$Message.success("操作成功");
              this.getList();
            }
            this.settlementShow = false;
            this.addForm.settleDate = '';
          });
        } else {
          this.settleLoading = false;
        }
      });
    },

    // 生成结算批次
    saveAddform() {
      this.settleLoading = true;
      this.$units.notCloseModal(this);
      this.addForm.type = "1";
      this.$refs['addFormRef'].validate((valid) => {
        if (valid) {
          this.$http({
            url: '/buz/commissionLog/batchAcceptCommission',
            type: "POST",
            data: this.addForm,
          }).then((res) => {
            this.settleLoading = false;
            if (res.httpCode == 1) {
              this.$Message.success("操作成功");
              this.getList();
            }
            this.addVisible = false;
          });
        } else {
          this.settleLoading = false;
        }
      });
    },
    // 新增批次
    addBatch() {
      this.addbatchVisible = true;
      this.addbatchForm = {};
    },
  },
};
</script>
<style lang='scss' scoped>
  .unit {
    margin-left: 10px;
    font-size: 14px;
  }

.content {
  .statistics-container {
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;
  .statistics-item {
    display: flex;
    margin-right: 20px;
    span{
      white-space: nowrap;
    }
    div{
      white-space: nowrap;
    }

    .dot {
      width: 4px;
      height: 4px;
      background: #236DFF;
      align-self: center;
      margin-right: 7px;
    }
    .num{
      color: #3C464F;
    }
  }
}
  /deep/.input-item.select-two.select-two1>:nth-child(1){
      width: 114px!important;
    }
  /deep/.titleBox {
    border-bottom: 0 !important;
  }
  .tab-box {
    position: relative;
    .tools-box {
      position: absolute;
      right: 0;
      z-index: 1;
      top: 0;
    }
  }
  /deep/ {
    .ivu-tabs-bar {
      border-bottom: 1px solid #ECECEC;
    }
    .ivu-tabs-ink-bar {
      display: none;
    }
    .ivu-tabs-tab {
      padding: 9px 0 10px;
      margin-right: 44px;
      font-size: 14px;
      color: #515C6F;
    }
    .ivu-tabs-tab-active{
      position: relative;
      color: #236DFF;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: 1px;
        height: 2px;
        width: 100%;
        background-color: #236DFF;
      }
    }
  }
}

.tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }

  .commission-price {
  display: flex;
  align-items: center;
  justify-content: center;
  .text-tag {
    margin-left: 5px;
    width: 34px;
    height: 20px;
    border-radius: 2px;
    font-size: 12px;
    color: #ff7f00;
    border: 1px solid #ffcf8e;
    background: #fff3e3;
  }
}


  .pop-tip {
    position: absolute;
    width: 190px;
    top: -50px;
    display: flex;
    align-items: center;
    text-align: left;
    left: 50%;
    margin-left: -50px;
    padding: 9px 10px;
    display: flex;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;

    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }

    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      bottom: -4px;
      left: 74px;
      transform: rotateZ(135deg);
    }
  }

/deep/ .tip-icon {
  margin-left: 3px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: transparent;
  border: 1px solid #000;
  color: #000;
  display: inline-block;
  text-align: center;
  line-height: 14px;
  font-size: 14px;
  cursor: pointer;
  top: 50%;
}
.toDetailPage{
  color: #236DFF;
  cursor: pointer;
}
.null{
    padding-left: 10px;
    line-height: 30px;
    white-space: nowrap;
  }
.dian {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: #35BF3F;
    border-radius: 50%;
    margin-right: 4px;
    &.red {
      background: #E3461F;
    }
  }
.btns {
  width: 100%;
  height: 40px;
  position: relative;
}
.btn {
  float: left;
  &:hover {
    cursor: pointer;
  }
  font-size: 12px;
  color: #236dff;
  float: left;
  padding: 0 12px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background-color: #F7F8FA;
  color: #727c8e;
  margin-right: 10px;
  border-radius: 5px;

  &.active {
    background: #236dff;
    color: #fff;
  }
}

</style>
<style lang="scss">
.commissionRecordModal {
  .ivu-modal-footer {
    padding-top: 0;
  }
  .page-form {
    .pc-wrap {
      .ivu-form-item-content {
        display: flex;
        button {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
